const screen = {
  xxs: '375px',
  xs: '480px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1440px',
  xxl: '1920px',
  xxxl: '2450px'
};

export { screen as default, screen };
//# sourceMappingURL=Screen.js.map
